import classNames from 'classnames';
import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { useTypedSelector } from '../../../../../hooks';
import { TermsBlock } from './TermsBlock';
import telephoneIcon from './icon-telephone.svg';
import storefrontIcon from './icon-storefront.svg';
import locationPinIcon from './icon-location-pin.svg';

export const TermsBlockCustomer = (): JSX.Element => {
  const isBusiness = useTypedSelector(state => state.generalTransport.contact.customer?.is_business);
  const customerDetails = useTypedSelector(state => state.generalTransport.contact.customer?.contact_details);
  const companyDetails = useTypedSelector(state => state.generalTransport.contact.customer?.company_details);
  const hasCompanyDetails = isBusiness && companyDetails?.coc_number && companyDetails?.vat_number;
  return (
    <div className={'pt-[1em]'}>
      <TermsBlock
        title={<Translate id={'request_flow.terms.block_heading.customer_details'} />}
        borderRadius="top"
        border="bottom"
      />
      <TermsBlock spacingX={false} spacingY={false} borderRadius="bottom" className="order-overview--split">
        <div
          className={classNames({
            'order-overview--split-left': hasCompanyDetails,
            'w-full': !hasCompanyDetails,
          })}
        >
          <TermsBlock
            icon={<img src={telephoneIcon} />}
            title={<Translate id={`request_flow.terms.block_heading.contact.customer`} />}
            borderRadius="none"
            border={isBusiness ? 'bottom' : 'none'}
          >
            <div>
              {customerDetails?.first_name} {customerDetails?.last_name}
            </div>
            <div>{customerDetails?.email}</div>
            <div>{customerDetails?.phone}</div>
          </TermsBlock>
          {isBusiness && (
            <TermsBlock
              icon={<img src={locationPinIcon} />}
              title={<Translate id={`request_flow.terms.block_heading.company_address`} />}
              borderRadius="none"
            >
              <div>{companyDetails?.company_name}</div>
              {companyDetails?.address?.line1 && <div>{companyDetails?.address?.line1}</div>}
              <div>
                {companyDetails?.address?.postal_code && companyDetails?.address.postal_code}{' '}
                {companyDetails?.address?.locality && companyDetails?.address.locality}
              </div>
            </TermsBlock>
          )}
        </div>
        {hasCompanyDetails && (
          <div className="order-overview--split-right">
            <TermsBlock
              icon={<img src={storefrontIcon} />}
              title={<Translate id={`request_flow.terms.block_heading.company_details`} />}
              borderRadius="none"
            >
              {companyDetails?.coc_number && (
                <div>
                  <Translate id="request_flow.terms.coc_abr" />: {companyDetails?.coc_number}
                </div>
              )}
              {companyDetails?.vat_number && (
                <div>
                  <Translate id="request_flow.terms.vat_abr" />: {companyDetails?.vat_number}
                </div>
              )}
            </TermsBlock>
          </div>
        )}
      </TermsBlock>
    </div>
  );
};
